import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { WebhookDefinitionRestService } from "@app/services/hal/webhook-definition-rest.service";
import { WebhookDefinition } from "@app/models/rest/webhook-definition";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class WebhookDefinitionStore extends RealTimeDataStore<WebhookDefinition> {
  constructor() {
    const webhookDefinitionRestService = inject(WebhookDefinitionRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      webhookDefinitionRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("WebhookDefinition");
  }
}
